(function () {
  'use strict';

  function initProductSection(root) {
    var form = root.querySelector('[data-product-form]');
    var jsonEl = root.querySelector('[data-product-json]');
    if (!form || !jsonEl) return;

    var productData;
    try {
      productData = JSON.parse(jsonEl.textContent).variants;
    } catch (e) {
      productData = [];
    }

    var idInput = form.querySelector('[data-product-form-variant-id]');
    var optionSelects = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]'));
    // priceEl/comparePriceEl/saveBadgeEl are queried from `root`, not `form`:
    // the bundle price row renders before the <form> opens (a sibling, not
    // a descendant), so form.querySelector never found them and variant
    // switches silently failed to update the displayed price/compare-at/
    // savings even though the hidden variant-id input (which IS inside the
    // form) updated correctly.
    var priceEl = root.querySelector('[data-product-price]');
    var comparePriceEl = root.querySelector('[data-product-compare-price]');
    var saveBadgeEl = root.querySelector('[data-product-save-badge]');
    var savePrefix = saveBadgeEl ? (saveBadgeEl.dataset.savePrefix || 'SAVE') : 'SAVE';
    var submitBtn = form.querySelector('[data-product-submit]');
    var submitText = form.querySelector('[data-product-submit-text]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');

    // ---- "Complete Your Ritual" upsell link (present on the Gua Sha, Face
    // Roller and Face Oil PDPs — absent on the Set page, which uses the
    // add-to-cart variant below instead, and absent everywhere else, so all
    // of this is a no-op there). Keeps the whole card — CTA link's
    // `?variant=` AND the displayed price/compare/save — in sync with
    // whichever Material the shopper currently has selected, since the
    // initial server-rendered card only reflects the page-load default and
    // radio changes here don't reload the page. The recommended product's
    // price (and, for the Set, its synthetic bundle savings) can differ per
    // Material, so both the link and the price row need updating, not just
    // the link. All price/compare/save text arrives already formatted from
    // Liquid (data-duo-variants) — money formatting/locale isn't available
    // in JS, so this only ever swaps in ready-made strings.
    var duoUpsellLink = root.querySelector('[data-duo-upsell-link]');
    var duoVariantMap = {};
    if (duoUpsellLink) {
      try {
        duoVariantMap = JSON.parse(duoUpsellLink.dataset.duoVariants || '{}');
      } catch (e) {
        duoVariantMap = {};
      }
    }
    function updateDuoUpsellLink(variant) {
      if (!duoUpsellLink || !variant || !variant.options) return;
      var materialIndex = parseInt(duoUpsellLink.dataset.materialIndex, 10);
      if (isNaN(materialIndex) || materialIndex < 0) return;
      var materialValue = variant.options[materialIndex];
      var entry = duoVariantMap[materialValue];
      if (!entry) return;

      duoUpsellLink.href = duoUpsellLink.dataset.duoBaseUrl + '?variant=' + entry.id;

      var priceEl = duoUpsellLink.querySelector('[data-ritual-upsell-price]');
      var wasEl = duoUpsellLink.querySelector('[data-ritual-upsell-was]');
      var saveEl = duoUpsellLink.querySelector('[data-ritual-upsell-save]');

      if (priceEl) priceEl.textContent = entry.price;
      if (wasEl) {
        wasEl.textContent = entry.onSale ? entry.compare : '';
        wasEl.hidden = !entry.onSale;
      }
      if (saveEl) {
        saveEl.textContent = entry.onSale ? 'SAVE ' + entry.save : '';
        saveEl.hidden = !entry.onSale;
      }
    }

    // ---- "Complete Your Ritual" add-to-cart CTA (Set page's Face Oil card
    // only — element absent everywhere else). Face Oil has no Material to
    // select, so this card adds it directly instead of linking through.
    var ritualAddButton = root.querySelector('[data-ritual-upsell-add-button]');
    if (ritualAddButton && window.fetch) {
      var ritualAddLabel = ritualAddButton.querySelector('[data-ritual-upsell-add-label]');
      var ritualCartDrawer = document.querySelector('cart-drawer');
      var ritualProductId = ritualAddButton.dataset.productId;
      var ritualDefaultCtaHTML = ritualAddButton.dataset.ctaText || (ritualAddLabel ? ritualAddLabel.textContent.trim() : '+ Add');

      function setRitualAddButtonState(inCart) {
        ritualAddButton.disabled = inCart;
        if (ritualAddLabel) {
          ritualAddLabel.innerHTML = inCart
            ? 'In Your Cart <span aria-hidden="true">✓</span>'
            : ritualDefaultCtaHTML;
        }
      }

      // Cart is the source of truth, not whatever this button last did —
      // re-checks /cart.js and flips the button in either direction
      // (e.g. reverts to "+ Add Face Oil" if the shopper later removes it
      // from the Cart Drawer). Wired to fire on every kind of cart
      // mutation below, not just this button's own click.
      function refreshRitualCartState() {
        if (!ritualProductId) return;
        fetch((window.routes.cart_url || '/cart') + '.js')
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            var inCart = cart.items.some(function (item) {
              return String(item.product_id) === String(ritualProductId);
            });
            setRitualAddButtonState(inCart);
          })
          .catch(function () {});
      }

      ritualAddButton.addEventListener('click', function () {
        if (ritualAddButton.disabled) return;
        var variantId = ritualAddButton.dataset.variantId;
        if (!variantId) return;

        ritualAddButton.disabled = true;
        if (ritualAddLabel) ritualAddLabel.textContent = 'Adding…';

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: ritualCartDrawer ? ritualCartDrawer.getSectionsToRender().map(function (section) { return section.id; }) : undefined,
            sections_url: window.location.pathname
          })
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (data.status) throw new Error(data.description || 'Could not add to cart');
            setRitualAddButtonState(true);
            if (ritualCartDrawer) {
              ritualCartDrawer.classList.remove('is-empty');
              ritualCartDrawer.renderContents(data);
            }
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          })
          .catch(function () {
            if (ritualAddLabel) ritualAddLabel.textContent = "Couldn't add — try again";
            ritualAddButton.disabled = false;
          });
      });

      // Two different signals cover every mutation path in this theme:
      // Dawn's own CartItems.updateQuantity (assets/cart.js) publishes
      // PUB_SUB_EVENTS.cartUpdate after every /cart/change.js response —
      // that's remove, quantity +/-, and any other Cart Drawer edit. Our
      // own fetch-based add flows (this button, the PDP form, the cart
      // drawer's recommendation/free-shipping-upsell "Add" buttons) don't
      // go through Dawn's publish() call, so they dispatch a plain
      // `cart:item-added` DOM event instead — listen for both rather than
      // relying on either alone.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshRitualCartState);
      }
      document.addEventListener('cart:item-added', refreshRitualCartState);

      // Also true up once on load, in case the cart changed in another
      // tab/window since this page was rendered.
      refreshRitualCartState();
    }

    // ---- "Ships by" date (business days from today, skipping weekends)
    var shipsDateEl = root.querySelector('[data-main-product-ships-date]');
    if (shipsDateEl) {
      var shipDays = parseInt(shipsDateEl.getAttribute('data-days'), 10);
      if (!shipDays || shipDays < 1) shipDays = 2;

      var addBusinessDays = function (startDate, count) {
        var date = new Date(startDate.getTime());
        var added = 0;
        while (added < count) {
          date.setDate(date.getDate() + 1);
          var dayOfWeek = date.getDay();
          if (dayOfWeek !== 0 && dayOfWeek !== 6) added++;
        }
        return date;
      };

      var shipTarget = addBusinessDays(new Date(), shipDays);
      shipsDateEl.textContent = shipTarget.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
    }

    // ---- Material Guide drawer
    var guideDrawer = root.querySelector('[data-material-guide-drawer]');
    var guideOpenBtn = root.querySelector('[data-material-guide-open]');
    if (guideDrawer && guideOpenBtn) {
      var guideCloseEls = Array.prototype.slice.call(root.querySelectorAll('[data-material-guide-close]'));
      var openGuide = function () {
        guideDrawer.classList.add('is-open');
        guideDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };
      var closeGuide = function () {
        guideDrawer.classList.remove('is-open');
        guideDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };
      guideOpenBtn.addEventListener('click', openGuide);
      guideCloseEls.forEach(function (el) { el.addEventListener('click', closeGuide); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && guideDrawer.classList.contains('is-open')) closeGuide();
      });

      // "Select" button on each material card — picks that material's radio
      // option (matched by name) and updates price/variant the same way
      // clicking the radio directly would, then closes the drawer.
      var guideSelectBtns = Array.prototype.slice.call(guideDrawer.querySelectorAll('[data-material-guide-select]'));
      var materialRadios = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"][data-product-option]'));
      guideSelectBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // The guide card's name setting is "Terahertz — Modern
          // Performance" style (material + subtitle), while the radio's
          // value is just "Terahertz" — match on the part before the
          // em dash rather than the full string.
          var materialName = (btn.getAttribute('data-material-guide-select') || '')
            .split('—')[0]
            .trim()
            .toLowerCase();
          var radio = materialRadios.filter(function (input) {
            return input.value.trim().toLowerCase() === materialName;
          })[0];
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          closeGuide();
        });
      });
    }

    // ---- Quantity stepper
    if (qtyInput && qtyMinus && qtyPlus) {
      var updateQtyMinusState = function () {
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyMinus.classList.toggle('is-at-min', value <= 1);
      };
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        updateQtyMinusState();
      });
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        updateQtyMinusState();
      });
      qtyInput.addEventListener('input', updateQtyMinusState);
      updateQtyMinusState();
    }

    // ---- Gallery: a single horizontal scroll-snap stage drives the
    // thumbnails (desktop) and dots (mobile) — see the section comment for
    // why there's only one copy of each media item.
    var galleryRoot = root.querySelector('[data-gallery-root]');
    var stage = galleryRoot && galleryRoot.querySelector('[data-gallery-stage]');
    var thumbs = galleryRoot ? Array.prototype.slice.call(galleryRoot.querySelectorAll('[data-gallery-thumb]')) : [];
    var dots = galleryRoot ? Array.prototype.slice.call(galleryRoot.querySelectorAll('.main-product__dot')) : [];
    var items = galleryRoot ? Array.prototype.slice.call(galleryRoot.querySelectorAll('[data-gallery-item]')) : [];
    var prevBtn = galleryRoot && galleryRoot.querySelector('[data-gallery-prev]');
    var nextBtn = galleryRoot && galleryRoot.querySelector('[data-gallery-next]');
    var currentIndex = 0;

    function setActiveIndex(index) {
      currentIndex = index;
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      items.forEach(function (item, i) {
        if (i === index) return;
        var video = item.querySelector('video');
        if (video && !video.paused) video.pause();
      });
      // Keep the active thumbnail visible if the thumbnail strip itself is
      // scrollable (more thumbnails than fit in the row) — doesn't move the
      // strip at all if it's already in view.
      var activeThumb = thumbs[index];
      if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    function scrollToIndex(index, smooth) {
      if (!stage || !items[index]) return;
      // `behavior: 'auto'` means "defer to the element's CSS scroll-behavior"
      // per spec, NOT "no animation" — and the stage has `scroll-behavior:
      // smooth` in CSS, so passing 'auto' here still animated. 'instant'
      // is the value that actually bypasses CSS and jumps immediately.
      stage.scrollTo({ left: items[index].offsetLeft, behavior: smooth === false ? 'instant' : 'smooth' });
      setActiveIndex(index);
    }

    function scrollToMediaId(mediaId, smooth) {
      var index = items.findIndex(function (item) { return item.getAttribute('data-media-id') === String(mediaId); });
      if (index > -1) scrollToIndex(index, smooth);
    }

    // Always land on the first image on every visit — opening the page
    // fresh, a plain refresh, or navigating back/forward into it. The
    // gallery stage is its own horizontally-scrollable element, and some
    // browsers restore ITS scroll position independently of the page's own
    // scroll position (most noticeable on back/forward, which restores
    // from bfcache without re-running this script's normal top-to-bottom
    // setup).
    if (stage) {
      // Force an instant jump regardless of the stage's own CSS
      // `scroll-behavior: smooth` (used for arrow/thumbnail navigation) —
      // setting scrollLeft directly already ignores that per spec, but
      // resetting the property explicitly here too means this can never
      // start animating even if that changes later.
      function hardResetToFirst() {
        var previous = stage.style.scrollBehavior;
        stage.style.scrollBehavior = 'auto';
        stage.scrollLeft = 0;
        stage.style.scrollBehavior = previous;
        setActiveIndex(0);
      }
      hardResetToFirst();
      // Reset again on 'pageshow' (fires on both a fresh load and a
      // bfcache restore) as a safety net for whichever position the
      // browser already restored by that point.
      window.addEventListener('pageshow', hardResetToFirst);
      // Also reset on 'pagehide', right before the browser snapshots this
      // page into bfcache — so the cached snapshot itself already shows
      // the first image, and a later back/forward restore has nothing to
      // visibly correct (no flash/flip back to image one).
      window.addEventListener('pagehide', function () {
        stage.scrollLeft = 0;
      });
    }

    // Clamps: left stops at the first (leftmost) image, right stops at the
    // last (rightmost) image — never wraps past either end.
    function clampIndex(index) {
      return Math.max(0, Math.min(items.length - 1, index));
    }

    function goToIndex(index, smooth) {
      scrollToIndex(clampIndex(index), smooth);
    }

    thumbs.forEach(function (thumb, index) {
      // Clicking a thumbnail jumps straight to that image — no slide/scroll
      // animation through the images in between.
      thumb.addEventListener('click', function () { goToIndex(index, false); });
    });

    // Left/right arrow keys move to the adjacent image, moving focus onto
    // the newly-active thumbnail so repeated presses keep working. Bound at
    // the document level — rather than only to the stage/thumbnails — so
    // this works the instant a shopper lands on the page and presses an
    // arrow key, with no click or Tab needed first to "activate" a specific
    // focus target. Ignored while focus is in a real form control (text
    // input, the qty field, a material radio) so typing/cursor-movement and
    // the native radio-group arrow behavior there are untouched.
    function handleGalleryArrowKey(e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var targetTag = (e.target.tagName || '').toLowerCase();
      if (targetTag === 'input' || targetTag === 'textarea' || targetTag === 'select' || e.target.isContentEditable) return;
      e.preventDefault();
      var nextIndex = clampIndex(currentIndex + (e.key === 'ArrowRight' ? 1 : -1));
      goToIndex(nextIndex);
      if (thumbs[nextIndex]) thumbs[nextIndex].focus();
    }
    document.addEventListener('keydown', handleGalleryArrowKey);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToIndex(currentIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToIndex(currentIndex + 1); });
    }

    // ---- Thumbnail row prev/next arrows: advance the active image (same
    // as clicking a thumbnail directly) — setActiveIndex's scrollIntoView
    // already keeps the strip scrolled to show whichever thumbnail is active.
    var thumbsPrevBtn = galleryRoot && galleryRoot.querySelector('[data-thumbs-prev]');
    var thumbsNextBtn = galleryRoot && galleryRoot.querySelector('[data-thumbs-next]');
    if (thumbsPrevBtn) thumbsPrevBtn.addEventListener('click', function () { goToIndex(currentIndex - 1); });
    if (thumbsNextBtn) thumbsNextBtn.addEventListener('click', function () { goToIndex(currentIndex + 1); });

    // `touch-action: manipulation` (CSS) already tells the browser these
    // buttons don't want double-tap-zoom, but as a second line of defense
    // on iOS Safari, also swallow the second touchend of a fast double/
    // multi-tap so the native zoom gesture never has a chance to fire —
    // single taps (the normal "advance one image" interaction) are
    // untouched since only a *repeat* touchend within the window is caught.
    [prevBtn, nextBtn, thumbsPrevBtn, thumbsNextBtn].forEach(function (btn) {
      if (!btn) return;
      var lastTouchEnd = 0;
      btn.addEventListener('touchend', function (e) {
        var now = Date.now();
        if (now - lastTouchEnd < 350) e.preventDefault();
        lastTouchEnd = now;
      }, { passive: false });
    });

    if (stage) {
      var scrollTimer = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(stage.scrollLeft / stage.clientWidth);
          setActiveIndex(index);
        }, 80);
      }, { passive: true });

    }

    // ---- Variant selection
    function findVariant() {
      if (optionSelects.length === 0) return productData[0];
      var byPosition = {};
      optionSelects.forEach(function (el) {
        if (el.type === 'radio' && !el.checked) return;
        byPosition[el.dataset.optionPosition] = el.value;
      });
      var selected = Object.keys(byPosition)
        .sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); })
        .map(function (position) { return byPosition[position]; });
      return productData.filter(function (variant) {
        return variant.options.length === selected.length && variant.options.every(function (value, i) { return value === selected[i]; });
      })[0];
    }

    function applyVariant(variant) {
      var available = !!variant && variant.available;

      if (idInput) idInput.value = variant ? variant.id : '';

      if (priceEl) priceEl.textContent = variant ? variant.price : '';
      if (comparePriceEl) {
        if (variant && variant.compareAtPrice) {
          comparePriceEl.textContent = variant.compareAtPrice;
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.hidden = true;
        }
      }
      if (saveBadgeEl) {
        if (variant && variant.save) {
          saveBadgeEl.textContent = savePrefix + ' ' + variant.save;
          saveBadgeEl.hidden = false;
        } else {
          saveBadgeEl.textContent = '';
          saveBadgeEl.hidden = true;
        }
      }

      [submitBtn, root.querySelector('[data-sticky-submit]')].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
      });
      var label = !variant ? 'Unavailable' : (available ? 'Add to Cart' : 'Sold Out');
      if (submitText) submitText.textContent = label;
      var stickySubmit = root.querySelector('[data-sticky-submit]');
      if (stickySubmit) stickySubmit.textContent = label;
      var stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice && variant) stickyPrice.textContent = variant.price;

      // Instant jump (no slide/animate-through) — matches Shopify's own
      // variant.featured_media as the source of truth for which gallery
      // image belongs to this variant, whatever position it's actually at.
      if (variant && variant.featuredMediaId) scrollToMediaId(variant.featuredMediaId, false);

      updateDuoUpsellLink(variant);
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        // A radio's native 'change' event only fires when the checked
        // option actually changes, so this naturally only resets qty on
        // a real variant switch — not on +/- clicks or re-clicking the
        // already-selected option. Only the *displayed* quantity input
        // resets; quantities already in the cart are untouched.
        if (qtyInput) {
          qtyInput.value = 1;
          if (typeof updateQtyMinusState === 'function') updateQtyMinusState();
        }
        applyVariant(findVariant());
      });
    });

    // ---- Add to cart (progressive enhancement: falls back to a normal
    // form submission if fetch isn't available or the request fails).
    if (window.fetch) {
      var cartDrawer = document.querySelector('cart-drawer');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitBtn.disabled) return;

        var originalLabel = submitText ? submitText.textContent : '';
        if (submitText) submitText.textContent = 'Adding…';
        submitBtn.disabled = true;

        fetch(form.getAttribute('data-cart-add-url') || form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: idInput.value,
            quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
            sections: cartDrawer ? cartDrawer.getSectionsToRender().map(function (section) { return section.id; }) : undefined,
            sections_url: window.location.pathname
          })
        })
          .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data && result.data.description || 'Could not add to cart');
            if (submitText) submitText.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: result.data }));
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(result.data);
            }
            return fetch((form.getAttribute('data-cart-url') || '/cart') + '.js');
          })
          .then(function (response) { return response && response.json(); })
          .then(function (cart) {
            if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));
          })
          .catch(function () {
            if (submitText) submitText.textContent = "Couldn't add — try again";
          })
          .finally(function () {
            setTimeout(function () {
              submitBtn.disabled = false;
              if (submitText) submitText.textContent = originalLabel;
            }, 1600);
          });
      });
    }

    // Sticky "Add to Cart" button on mobile just proxies the real form.
    var stickyBar = root.querySelector('[data-sticky-bar]');
    var stickySubmitBtn = root.querySelector('[data-sticky-submit]');
    if (stickySubmitBtn) {
      stickySubmitBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else submitBtn.click();
      });
    }
    if (stickyBar && submitBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // 2026-08-24, per request: the bar should only appear once the
        // user has scrolled *past* the real Add to Cart button (i.e. it's
        // now above the viewport), not just whenever that button happens
        // to be off-screen — !isIntersecting alone was also true before
        // the user ever scrolled at all, on tall product pages where the
        // real button starts out below the fold, so the bar was showing
        // immediately on page load instead of only after scrolling by.
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      }, { threshold: 0 });
      io.observe(submitBtn);
    }
  }

  document.querySelectorAll('[data-section-id]').forEach(function (root) {
    if (root.querySelector('[data-product-form]')) initProductSection(root);
  });
})();
